import type {KeyTextField} from '@prismicio/client'
import type {Top10AiToolsSliceDefaultItem} from 'prismicio-types'
import React from 'react'

interface Props {
  eyebrow: KeyTextField
  title: KeyTextField
  tools: Top10AiToolsSliceDefaultItem[]
}

const DeepDives: React.FC<Props> = ({eyebrow, title, tools}) => {
  const reversed = tools.slice().sort((a, b) => (b.rank ?? 0) - (a.rank ?? 0))

  return (
    <section style={{maxWidth: 1180, margin: '0 auto', padding: '96px 32px'}}>
      {eyebrow && <p className="t10-eyebrow">{eyebrow}</p>}
      {title && (
        <h2 className="t10-section-title" style={{maxWidth: '22ch', marginBottom: 56}}>
          {title}
        </h2>
      )}

      <div className="t10-deep-dives">
        {reversed.map((t, i) => {
          const yoyColor = (t.yoy ?? 0) < 0 ? '#FF7A7A' : '#B4FF44'
          const cardBg = t.featured ? 'rgba(180,255,68,0.05)' : 'rgba(255,255,255,0.03)'
          const cardBorder = t.featured ? 'rgba(180,255,68,0.28)' : 'rgba(255,255,255,0.10)'

          return (
            <article key={i} className="t10-card" style={{background: cardBg, border: `1px solid ${cardBorder}`}}>
              <div className="t10-card-bg-rank">{t.rank}</div>
              <div className="t10-card-inner">
                <div className="t10-card-header">
                  <div>
                    <div className="t10-card-meta">
                      <span className="t10-card-rank-badge">#{t.rank}</span>
                      <span className="t10-card-cat-badge">{t.cat}</span>
                      {t.featured && <span className="t10-card-featured-badge">The duopoly</span>}
                    </div>
                    <h3 className="t10-card-name">
                      {t.name} {t.product && <span className="t10-card-product">{t.product}</span>}
                    </h3>
                  </div>
                </div>

                <div className="t10-card-stats">
                  <div className="t10-card-stat">
                    <div className="t10-card-stat-label">Total spend</div>
                    <div className="t10-card-stat-val">{t.spend_str}</div>
                  </div>
                  <div className="t10-card-stat">
                    <div className="t10-card-stat-label">Spend share</div>
                    <div className="t10-card-stat-val">{t.share}%</div>
                  </div>
                  <div className="t10-card-stat">
                    <div className="t10-card-stat-label">YoY growth</div>
                    <div className="t10-card-stat-val" style={{fontWeight: 500, color: yoyColor}}>
                      {t.yoy_str}
                    </div>
                  </div>
                </div>

                {t.blurb && <p className="t10-card-blurb">{t.blurb}</p>}

                <div className="t10-card-details">
                  {t.features && (
                    <div>
                      <div className="t10-card-detail-label">Key features in 2026</div>
                      <p className="t10-card-detail-text">{t.features}</p>
                    </div>
                  )}
                  {t.pricing && (
                    <div>
                      <div className="t10-card-detail-label">Pricing</div>
                      <p className="t10-card-detail-text">{t.pricing}</p>
                    </div>
                  )}
                  {t.best_for && (
                    <div>
                      <div className="t10-card-detail-label">Who it&apos;s best for</div>
                      <p className="t10-card-detail-text">{t.best_for}</p>
                    </div>
                  )}
                </div>
              </div>
            </article>
          )
        })}
      </div>
    </section>
  )
}

export default DeepDives
